<template>
	<el-tooltip
		:content="translations.labels.sortBy"
		class="slot"
		effect="dark"
		placement="top"
	>
		<el-select
			v-model="sortBy"
			size="medium"
			style="width: 160px"
		>
			<el-option
				v-for="item in sortOptions"
				:key="item.label"
				:label="item.label"
				:value="item.id"
			/>
		</el-select>
	</el-tooltip>
</template>

<script>
import { EventBus } from '@/services/event-bus'

export default {
    name: 'Sort',
	data () {
		return {
			sortBy: 1,
			sortOptions: [
				{
					id: 1,
					label: 'A-Z'
				},
				{
					id: 2,
					label: 'Z-A'
				},
				{
					id: 3,
					label: null
				},
				{
					id: 4,
					label: null
				}
			]
		}
	},
	mounted () {
		this.sortOptions[2].label = this.translations.labels.newestFirst
		this.sortOptions[3].label = this.translations.labels.oldestFirst
	},
	watch: {
		'sortBy' () {
			let sortCriteria
			let sortBy
			if (this.sortBy === 1) {
				sortCriteria = 'asc'
				sortBy = 'title'
			}
			if (this.sortBy === 2) {
				sortCriteria = 'desc'
				sortBy = 'title'
			}
			if (this.sortBy === 3) {
				sortCriteria = 'desc'
				sortBy = 'createdAt'
			}
			if (this.sortBy === 4) {
				sortCriteria = 'asc'
				sortBy = 'createdAt'
			}
			EventBus.$emit('change-sort', {
				sortCriteria: sortCriteria,
				sortBy: sortBy
			})
		}
	}
}
</script>
